"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var classNames = require("classnames");
var nodash_1 = require("../../utils/nodash");
var Input_1 = require("../Input");
var nodash_2 = require("../../utils/nodash");
// TODO: this is a forked version of the dependency to use some changes
// before they are released. Switch back to main repo as soon as the PR
// https://github.com/reactjs/react-autocomplete/pull/357 is merged
var ReactAutocomplete = require('@flash1293/react-autocomplete'); // eslint-disable-line @typescript-eslint/no-var-requires
// maximum height of suggestion list box in px
var SUGGESTIONS_MAX_HEIGHT = 400;
/**
 * Number of milliseconds to wait between handling of scroll-events.
 */
var scrollThrottleWait = 300;
var propTypes = {
    onChange: PropTypes.func,
    renderInput: PropTypes.func,
    suggestions: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.shape({
            title: PropTypes.string,
            items: PropTypes.arrayOf(PropTypes.string).isRequired
        })
    ]))
};
var isItemSelectable = function (item) {
    return item.type === 'item' || item.type === 'group-item';
};
var getItemValue = function (item) {
    return item.value;
};
var getItems = function (suggestions) {
    return suggestions.reduce(function (prev, curr, index) {
        if (typeof curr === 'string') {
            prev.push({
                type: 'item',
                value: curr,
                key: curr
            });
        }
        else {
            if (curr.title) {
                prev.push({
                    type: 'header',
                    value: curr.title,
                    key: "header-" + curr.title
                });
            }
            if (curr.items.length > 0) {
                prev = prev.concat(curr.items.map(function (item) {
                    return {
                        type: 'group-item',
                        value: item,
                        key: (curr.title || index) + "-" + item
                    };
                }));
            }
        }
        return prev;
    }, []);
};
var AutocompleteWithinContext = /** @class */ (function (_super) {
    __extends(AutocompleteWithinContext, _super);
    function AutocompleteWithinContext(props) {
        var _this = _super.call(this, props) || this;
        _this.initiallyOpenRerender = false;
        _this.setMenuPositions = function () {
            if (_this.autocompleteRef) {
                _this.autocompleteRef.setMenuPositions();
            }
        };
        if (props.open) {
            _this.initiallyOpenRerender = true;
        }
        _this.id = props.ergoElements.idGenerator.next();
        _this.rerenderThrottled = nodash_2.throttle(function () {
            _this.forceUpdate();
        }, scrollThrottleWait, false);
        return _this;
    }
    AutocompleteWithinContext.prototype.componentDidUpdate = function () {
        if (this.initiallyOpenRerender === true) {
            this.initiallyOpenRerender = false;
            this.forceUpdate();
        }
    };
    AutocompleteWithinContext.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.rerenderThrottled);
        window.addEventListener('scroll', this.rerenderThrottled);
        /* istanbul ignore if */
        if (typeof MutationObserver === 'function') {
            this.mutationObserver = new MutationObserver(this.setMenuPositions);
            this.mutationObserver.observe(this.childElementRef, {
                attributes: true,
                characterData: true,
                childList: true,
                subtree: true
            });
        }
    };
    AutocompleteWithinContext.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.rerenderThrottled);
        window.removeEventListener('scroll', this.rerenderThrottled);
        /* istanbul ignore if */
        if (typeof MutationObserver === 'function') {
            this.mutationObserver.disconnect();
        }
    };
    AutocompleteWithinContext.prototype.render = function () {
        var _this = this;
        var _a = this.props, suggestions = _a.suggestions, onChange = _a.onChange, className = _a.className, children = _a.children, renderInput = _a.renderInput, ergoElements = _a.ergoElements, other = __rest(_a, ["suggestions", "onChange", "className", "children", "renderInput", "ergoElements"]);
        var suggestionItems = getItems(suggestions);
        return (React.createElement(ReactAutocomplete, __assign({ wrapperProps: {
                ref: function (el) {
                    _this.element = el;
                },
                className: classNames(className, 'ee_autocomplete')
            }, ref: function (el) {
                _this.autocompleteRef = el;
            }, getItemValue: getItemValue, isItemSelectable: isItemSelectable, items: suggestionItems, inputProps: other, onChange: function (e) {
                onChange(e.target.value);
            }, onSelect: function (value) { return onChange(value); }, renderMenu: function (items, _value, style) {
                // elementBottom is the y coordinate of the element in relation to the
                // viewport
                var elementBottom = _this.element ? _this.element.getBoundingClientRect().bottom : 0;
                // to calculate the max-height, we have to subtract the bottom y coordinate
                // from the viewport height (and some more pixels to get a small gap)
                var maxHeight = Math.min(SUGGESTIONS_MAX_HEIGHT, window.innerHeight - elementBottom - 5) + 'px';
                // return empty script tag when there are no autocomplete items so it doesn't
                // linger around and interfer with the AutosizeInput
                if (items.length === 0) {
                    return React.createElement("script", null);
                }
                // update the min width after the weight distribution within a FormRow component
                // is completed
                var minWidth = style.minWidth;
                if (_this.childElementRef) {
                    minWidth = _this.childElementRef.firstChild.getBoundingClientRect().width;
                }
                return (React.createElement("span", { id: _this.id, role: "listbox", className: "ee_autocomplete__menu", style: { minWidth: minWidth, maxHeight: maxHeight, overflow: 'auto' } }, items));
            }, renderItem: function (item, isHighlighted) { return (React.createElement("span", { key: item.key, className: classNames('ee_autocomplete__item', {
                    'ee_autocomplete__item--selected': isHighlighted,
                    'ee_autocomplete__item--header': item.type === 'header',
                    'ee_autocomplete__item--grouped': item.type === 'group-item'
                }), "aria-selected": isHighlighted, role: item.type === 'item' ? 'option' : undefined }, item.value)); }, renderInput: function (inputProps) { return (React.createElement("span", { ref: function (ref) {
                    _this.childElementRef = ref;
                } }, renderInput(inputProps, _this.id))); } }, other)));
    };
    AutocompleteWithinContext.propTypes = propTypes;
    AutocompleteWithinContext.defaultProps = {
        onChange: nodash_1.noop,
        suggestions: [],
        renderInput: function (props, menuId) { return (React.createElement(Input_1.Input, __assign({}, props, { ref: function (el) { return el && props.ref(el.input); }, "aria-owns": menuId }))); },
        ergoElements: undefined
    };
    return AutocompleteWithinContext;
}(React.Component));
exports.AutocompleteWithinContext = AutocompleteWithinContext;
//# sourceMappingURL=AutocompleteWithinContext.js.map